import VocaListContainer from '../../containers/admin/VocaListContainer';

export default function VocaPage() {
    return (
        <VocaListContainer />
    );
}
